// biome-ignore lint/correctness/noUnusedImports: existing error
import React, {FC} from 'react';
import {Typography} from '~library/atoms/Typography';

interface LabelProps {
  value: string;
  'data-qa-id'?: string;
}

export const Label: FC<LabelProps> = ({value, 'data-qa-id': dataQaId}) => (
  <Typography variant="label2" classNames="view-invitation__label" data-qa-id={dataQaId}>
    {value}
  </Typography>
);
